import { useQuery } from '@tanstack/react-query';
import { getProducts } from '../api/products/getProducts';
import type { Product } from '../@types/product';

export const useProducts = (): {
  initializing: boolean;
  isError?: boolean;
  products?: Product[];
} => {
  const { isLoading, isError, data } = useQuery<Product[], Error>({
    queryKey: ['products'],
    queryFn: getProducts,
  });

  return {
    initializing: isLoading || isError,
    isError,
    products: data,
  };
};
